<div class="container">
  <div class="merchant-business-card-container">
    <div class="merchant-background-image">
      <img src="{{ merchant?.coverPhotoURL ?? 'assets/merchant-background-placeholder.svg' }}">
    </div>
    <div class="merchant-business-card">
      <div class="merchant-business-card-image">
        <img src="{{ merchant?.profilePictureURL ?? 'assets/merchant-placeholder.svg' }}">
      </div>
      <div class="merchant-business-card-info-container">
        <p class="merchant-name">{{ merchant?.name }}</p>
        <!--        <p class="merchant-location">Cairo, Egypt</p>-->
        <!--        <div class="merchant-category-container">-->
        <!--          <p class="merchant-category">Category name</p>-->
        <!--        </div>-->
        <div class="claim-business-container" *ngIf="merchant !== null && !merchant?.claimed">
          <p i18n="@@yourRestaurant">Is this your business?</p>
          <div (click)="claimBusiness()">
            <span class="claim-business" i18n="@@claimBusinessNow">Claim business now</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="tabs-container">
    <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="tabs">
      <a mat-tab-link
         (click)="activeLink = 'home'"
         [routerLink]="'./'"
         [active]="activeLink === 'home'">
        <div class="tab-item">
          <img src="assets/home-icon.svg">
          <p class="tab-label"
             [style.font-weight]="activeLink === 'home' ? '600 !important' : '500 !important'"
             i18n="@@home">Home</p>
        </div>
      </a>

      <a mat-tab-link
         (click)="activeLink = 'menu'"
         [routerLink]="'menu'"
         [active]="activeLink === 'menu'">
        <div class="tab-item">
          <img src="assets/restraunt-icon.svg">
          <p class="tab-label"
             [style.font-weight]="activeLink === 'menu' ? '600 !important' : '500 !important'"
             i18n="@@menu">Menu</p>
        </div>
      </a>

      <a mat-tab-link
         (click)="activeLink = 'reviews'"
         [routerLink]="'reviews'"
         [active]="activeLink === 'reviews'">
        <div class="tab-item">
          <img src="assets/review-icon.svg">
          <p class="tab-label" [style.font-weight]="activeLink === 'reviews' ? '600 !important' : '500 !important'">
            Reviews</p>
        </div>
      </a>

      <a mat-tab-link
         (click)="activeLink = 'images&videos'"
         [routerLink]="'gallery'"
         [active]="activeLink === 'gallery'">
        <div class="tab-item">
          <img src="assets/gallery-icon.svg" class="gallery-icon">
          <p class="tab-label"
             [style.font-weight]="activeLink === 'gallery' ? '600 !important' : '500 !important'"
             i18n="@@gallery">Gallery</p>
        </div>
      </a>

      <!--    <a mat-tab-link-->
      <!--       (click)="activeLink = 'location'"-->
      <!--       [routerLink]="'location'"-->
      <!--       [active]="activeLink === 'location'">-->
      <!--      <div class="tab-item">-->
      <!--        <img src="assets/location-icon.svg">-->
      <!--        <p class="tab-label" [style.font-weight]="activeLink === 'location' ? '600 !important' : '500 !important'">-->
      <!--          Location</p>-->
      <!--      </div>-->
      <!--    </a>-->
    </nav>
    <mat-tab-nav-panel #tabPanel>
      <router-outlet></router-outlet>
    </mat-tab-nav-panel>
  </div>
</div>
